/**
 * Better Auth browser client.
 *
 * Same origin as the API, so the session cookie is first-party and needs no
 * CORS credentials dance. baseURL is left to default for that reason.
 */

import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  plugins: [magicLinkClient()],
});

export const { useSession, signIn, signOut } = authClient;
